import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardAdmin } from 'src/app/shared/guards/admin.guard';

import { OrdersHistoryComponent } from './orders-history.component';


const routes: Routes = [
    { path: '', component: OrdersHistoryComponent },
 
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrdersHistoryRoutingModule { }
